import { css } from "@emotion/core";
export const style = {
    contain: css `
    position: relative;
    display: inline-block;
    overflow: hidden;
  `,
    filter: css `
    filter: blur(3px);
  `,
    mask: css `
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background: rgba(0, 0, 0, 0.2);
  `,
    eye: css `
    width: 44px;
    height: 25px;
  `,
    text: css `
    margin-top: 4px;
    font-size: 16px;
    color: #fff;
    line-height: 1.5;
  `
};
